import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import EventEditPages from '../components/event/EventEditPages';
import '../css/style.css';
import '../components/Home.css';
import {GREEN_BG, GREEN_BORDER} from '../backend/Colors';

class EventEditLayout extends Component {

    render(){
        const { params } = this.props.match
        return (
            <SimpleLayout bg={GREEN_BG} bgStrong={GREEN_BORDER} >
                <EventEditPages id={params.id}/>
            </SimpleLayout>              
        );
    }

}

export default EventEditLayout;